export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bac299771a6e3c9cc86f6fd764767891.jpg"
          alt="SafePoint Solutions Security Services"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Securing What Matters Most
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
          Combining security expertise, storm preparedness, and preventative maintenance into one trusted service
        </p>
        <p className="text-lg text-gray-300 mb-12 max-w-2xl mx-auto">
          With over 20 years of state and federal law enforcement experience, we protect your investment and reduce risks
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollToSection('services')}
            className="px-8 py-4 bg-teal-600 text-white text-base font-semibold rounded-lg hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Explore Our Services
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-white text-slate-900 text-base font-semibold rounded-lg hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get in Touch
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('about')}
          className="text-white cursor-pointer"
          aria-label="Scroll to about section"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}